import { Component, OnInit, Input } from '@angular/core';
import { StyleService } from 'app/infrastructure/services/style.service';
import { EntityChildElement } from '../model/EntityChildElement';
import { Router, ActivatedRoute } from '@angular/router';
import { EntityAction } from '../model/EntityActions';

@Component({
  selector: 'selected-child-component',
  templateUrl: './selected-child.component.html'
})
export class SelectedChildComponent implements OnInit {
  @Input('entitySelectElement') entitySelectElement: EntityChildElement;
  constructor(private styleService: StyleService, private router: Router,
    private aRoute: ActivatedRoute) { }

  ngOnInit() {
    this.styleService.addStyle('SelectedChildComponent', require('./selected-child.component.css'));
  }

  NavigateAction(Action: EntityAction) {
    if (Action.route !== null)
      this.router.navigate(["." + this.entitySelectElement.route + Action.route], { relativeTo: this.aRoute });
  }

  Navigate(entitychild: EntityChildElement) {
    this.router.navigate(["." + this.entitySelectElement.route + entitychild.route], { relativeTo: this.aRoute });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/sidebar-selected-child/selected-child.component.ts